import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const WarehouseStockPage = lazy(
  () => import('@/pages/warehouse-stock/ui/index'),
)

export const Route = createFileRoute('/_protected/warehouse/stock')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <WarehouseStockPage />
    </Suspense>
  ),
})
